import { SelectionModel } from '@angular/cdk/collections';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { City } from 'app/masters/models/branch-master.model';
import { LocationService } from '../../location.service';

@Component({
  selector: 'app-search-city-master',
  templateUrl: './search-city-master.component.html',
  styleUrls: ['./search-city-master.component.scss']
})
export class SearchCityMasterComponent implements OnInit {
  dataSource = new MatTableDataSource<City>();
  selection = new SelectionModel<any>(true, []);
  displayedColumns: string[] = ['cityName', 'districtname', 'stateName', 'countryName', 'isActive'];
  showspinner = false;
  constructor(public dialog: MatDialog, public locationService: LocationService,public dialogRef: MatDialogRef<SearchCityMasterComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.getCityList();
    this.locationService.selecteCityData = null;

     this.dataSource.filterPredicate = (data: any, filter: string) => {
    const dataStr = (
      data.cityName + ' ' +
      data.districtname + ' ' +
      data.stateName + ' ' +
      data.countryName
    ).toLowerCase();

    return dataStr.includes(filter.trim().toLowerCase());
  };
  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  getCityList() {
    this.showspinner = true;
    this.locationService.getCity().subscribe(data => {
      this.dataSource.data = data
      this.showspinner = false;
    });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  selectRow(row) {
    this.selection.toggle(row);
    this.locationService.selecteCityData = row;
    this.dialogRef.close();
  }
  /** Close popup */
  closedialog() {
    this.dialogRef.close();
  }
}
